import axiosInstance from "@js-app/services/http/axios-instance";

class _ExportApi {
    getAll() {
        return axiosInstance.get('/export/all', {
            withCredentials: true,
        });
    }

    downloadExportFile(reportUUID, type) {
        return axiosInstance.post(`/export/download`, {
            report_uuid: reportUUID,
            type
        }, {
            responseType: "blob",
            withCredentials: true,
        });
    }

}

export const ExportApi = new _ExportApi();
